module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/doctors/noimage_s500x500-f351fce566d2ea1ad6915b210015b357.jpg";